
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card v-if="dialog" style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Aprovação de Execução de formulário</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <template v-if="loading_done_approval">
            <v-col justify="center">
              <card-loading-transparent loadingText="Carregando"></card-loading-transparent>
            </v-col>
          </template>
          <template v-if="!loading_done_approval && done_approval.id">
            <v-form ref="approForm">
              <div class="title">
                Você aprova essa execução?
              </div>
              <v-row justify="center" align="center">
                <v-col class="text-center">
                  <v-btn block :x-large="done_approval.status == 'rejected'" rounded :color="done_approval.status == 'approved'? 'grey lighten-2' : 'error'" @click="done_approval.status = 'rejected'" >
                    <v-icon>thumb_down</v-icon>
                  </v-btn>
                </v-col>
                <v-col class="text-center">
                  <v-btn block :x-large="done_approval.status == 'approved'" rounded :color="done_approval.status == 'rejected'? 'grey lighten-2' :'success'" @click="done_approval.status = 'approved'" >
                    <v-icon>thumb_up</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-textarea outlined dense v-model="done_approval.comment" prepend-icon="mdi-chat" 
                  :label="'Motivos ' + (done_approval.status == 'rejected'? '(obrigatório)': '(opcional)')"
                  :rules="done_approval.status == 'rejected'? required : []"
                ></v-textarea>
              </v-row>

              <template v-if="needs_to_sign">
                <v-col align="center" :style="`border: solid 1px #${alerted_sign? 'F00' : 'aaa'}; border-radius: 12px;`" class="pa-0" >
                <v-subheader>Assinatura: </v-subheader>
                  <VueSignaturePad v-if="needs_to_sign"
                    ref="signaturePad"
                    height="200px"
                    :customStyle="{ backgroundColor: '#f5f5f5', borderRadius: '12px'}"
                    :options="{ onBegin, onEnd }"
                  />

                </v-col>
                <v-row class="px-3" >
                  <v-col align="right">
                    <v-row>
                    <v-btn text color="error" @click="undo()" rounded><v-icon left>mdi-undo</v-icon>Desfazer</v-btn>
                    <v-btn depressed  color="success" :disabled="!signed" @click="save()" rounded><v-icon left>mdi-check</v-icon>confirmar</v-btn>

                    </v-row>
                  </v-col>
                </v-row>
              </template>
              <template v-if="typeof(done_approval.signature_img_url) == 'string'">
                <v-subheader>Assinatura:</v-subheader>
                <v-img class="mt-2" :src="done_approval.signature_img_url" max-height="500px" contain :aspect-ratio="2/1"></v-img>
              </template>
            </v-form>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn text color="error" @click="$emit('close')">Cancelar</v-btn>
          <v-btn text color="primary" @click="submitApproval()">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="saving" loadingText='Salvando'></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import CardLoadingTransparent from '../../../../components/shared/CardLoadingTransparent.vue';
import transform_signature_to_signed_id from '../../../../utils/transform_signature_to_direct_upload';
import active_solution_mixin from '@/mixins/active_solution'

export default {
  name: 'DialogApproveFlow',
  props: {
    one_done_approval: {
      type: Object,
      default: () => {}
    },
  },
  mixins: [ validations, active_solution_mixin ],
  components: {
    CardLoadingTransparent
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,

      loading_done_approval: false,
      done_approval: {},

      signature_img: null,
      signed: false,
      alerted_sign: false,

      saving: false,
    }
  },
  methods: {
    submitApproval(){
      if (this.$refs.approForm.validate() && (!this.needs_to_sign || this.needs_to_sign && this.signed)){
        // console.log('deu');
        this.sendApproval()
      } else if (this.done_approval.status == 'pending'){
        let obj = {
          type: 'error',
          msg: `Aprove ou rejeite o item.`
        }
        this.addNotification(obj)
      } else if (this.needs_to_sign && !this.signed){
        let obj = {
          type: 'error',
          msg: 'É necessário assinar para confirmar'
        }
        this.alerted_sign = true
        this.addNotification(obj)
      } else {
        console.log('num deu...');
      }
    },
    async sendApproval(){
      // console.log('asdfasdf');
      try {
        this.saving= true
        if (this.needs_to_sign){
          await this.setupSignatureToSend()
        }
        this.done_approval.done_at = this.$moment().toISOString()
        this.done_approval.done_by_id = this.profile.id

        Api.DoneApproval.update(this.done_approval).then(r=>r.data).then(d=> {
          // this.$router.push({name: 'ListingFlow'})
          this.$emit('done', d);
        }).catch((err) => {
          let obj = {
            type: 'error',
            msg: 'Erro: '+err
          }
          this.addNotification(obj)
        }).finally(()=>{
          this.saving= false
        })
      } catch (error) {
        
      }
    },
    async setupSignatureToSend(){
      try {
        let sig_signeds = await transform_signature_to_signed_id(this.signature_img)
        // console.log({sig_signeds});
        this.done_approval.signature_img = sig_signeds
      } catch (error) {
        let obj = {
          type: 'error',
          msg: 'Erro na assinatura: '+error
        }
        this.alerted_sign = true
        this.addNotification(obj)
      }
    },
    onBegin() {
      console.log('=== Begin ===');
    },
    onEnd() {
      console.log('=== End ===');
      this.signed = true
      this.save()
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
      if (this.$refs.signaturePad.isEmpty() ){
        this.signed = false
      }
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      // console.log(isEmpty);
      // console.log(data);

      if (!isEmpty){
        this.alerted_sign = false
        this.signature_img = {}

        this.signature_img.data = data
        this.signature_img.filename = `${new Date().getTime()}.png`
        this.signature_img.content_type = "image/png"
        // content_type:"image/jpeg"
        // exif:null
        // filename:"m-av.jpg"
        // info:Object
        //   aspectRatio:1
        //   modifiedDate:undefined
        //   modifiedTimestamp:1578403623000
        //   name:"m-av.jpg"
        //   newHeight:800
        //   newWidth:800
        //   orgHeight:512
        //   orgWidth:512
        //   type:"image/jpeg"
      } else {
        let obj = {
          type: 'error',
          msg: 'É necessário assinar para confirmar'
        }
        this.addNotification(obj)
      }
    },
    setDoneApproval() {
      this.done_approval = {...this.one_done_approval};
    },
    // getDoneApproval(){
    //   this.loading_done_approval = true
    //   Api.DoneApproval.index({flow_id: this.one_flow.id, version: this.one_flow.version_control}).then(r=> r.data).then(d=>{
    //     d = d[0]
    //     this.done_approval = {...d}
    //   }).catch(err=> {
    //     console.log({err});
    //   }).finally(()=> {
    //     this.loading_done_approval = false
    //   })
    // },  
    ...mapActions({
      // function: 'Module/action'
      addNotification: 'Notification/add'
    })
  },
  mounted () {
    // this.getDoneApproval();
    this.setDoneApproval();
  },
  computed: {
    needs_to_sign(){
      if (this.done_approval.needs_signature){
        const needs = this.done_approval.needs_signature && !this.done_approval.signature_img_url
        return needs
      }
      return false
    },
    ...mapState({
      // one_flow: state => state.ConfigFlow.one_flow,
      profile: state => state.User.oneUser,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
    
      } else if (nv == false){
        this.$emit('close')
      }
    }
  },
}
</script>

<style scoped>

</style>